module.exports = __webpack_public_path__ + "static/lighthouse-6c96944e552a05298bad0726a0e83a42.png";